import { render, staticRenderFns } from "./ServeItem.vue?vue&type=template&id=53dbb46e"
import script from "./ServeItem.vue?vue&type=script&lang=js"
export * from "./ServeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports